import { setDirectusToken } from '../../../utils/localStorage';

const DIRECTUS_URL = process.env.REACT_APP_DIRECTUS_URL;
const DIRECTUS_EMAIL = process.env.REACT_APP_DIRECTUS_EMAIL;
const DIRECTUS_PASSWORD = process.env.REACT_APP_DIRECTUS_PASSWORD;

export async function loginDirectus(
  user,password
) {
  if (!DIRECTUS_URL) {
    console.error('[Directus] REACT_APP_DIRECTUS_URL fehlt.');
    throw new Error('REACT_APP_DIRECTUS_URL fehlt.');
  }
  if (!DIRECTUS_EMAIL || !DIRECTUS_PASSWORD) {
    console.error('[Directus] Zugangsdaten fehlen.');
    throw new Error('REACT_APP_DIRECTUS_EMAIL/REACT_APP_DIRECTUS_PASSWORD fehlt.');
  }

  console.info('[Directus] Login start', {
    url: `${DIRECTUS_URL}/auth/login`,
    email: user,
    password: password
  });

  const response = await fetch(`${DIRECTUS_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: user,
      password: password
    })
  });

  if (!response.ok) {
    let responseText = '';
    try {
      responseText = await response.text();
    } catch (error) {
      responseText = `[body read failed: ${error.message}]`;
    }
    console.error('[Directus] Login failed', {
      status: response.status,
      statusText: response.statusText,
      responseText
    });
    throw new Error(`Directus-Login fehlgeschlagen: ${response.status}`);
  }

  const payload = await response.json();
  const accessToken = payload?.data?.access_token;
  if (!accessToken) {
    console.error('[Directus] Login ok, aber kein access_token vorhanden.', payload);
    throw new Error('Directus-Login ohne access_token.');
  }

  setDirectusToken(accessToken);
  console.info('[Directus] Login ok', { hasToken: true });
  return accessToken;
}
